export const PAYMENT_CUSTOMER_ACCOUNT_MODES = {
    none: "none",
    optional: "optional",
    required: "required"
};

const validModes = new Set(Object.values(PAYMENT_CUSTOMER_ACCOUNT_MODES));

export const resolvePaymentCustomerAccountMode = field => {
    if (field?.mode !== "take-payment") return PAYMENT_CUSTOMER_ACCOUNT_MODES.required;
    const configuredMode = field?.customerAccountMode?.toString().trim().toLowerCase();
    if (validModes.has(configuredMode)) return configuredMode;

    // An explicit but unrecognised value is malformed current configuration, not legacy configuration. Match the
    // server's fail-closed interpretation so opening the form cannot silently weaken it to guest-only.
    if (configuredMode) return PAYMENT_CUSTOMER_ACCOUNT_MODES.required;

    // Guest payment predates the explicit account-mode setting. Preserve what an existing form does when it is
    // opened in the builder, while keeping older account-backed forms on their established required-account path.
    return field?.allowGuestPayment === true
        ? PAYMENT_CUSTOMER_ACCOUNT_MODES.none
        : PAYMENT_CUSTOMER_ACCOUNT_MODES.required;
};

export const normalizePaymentCustomerAccountSettings = field => {
    if (field?.type !== "payment") return field;

    const customerAccountMode = resolvePaymentCustomerAccountMode(field);
    return {
        ...field,
        customerAccountMode,
        // Keep this legacy flag conservative for older readers. Optional account mode needs the explicit per-payment
        // choice and must not be mistaken for an always-guest field.
        allowGuestPayment: customerAccountMode === PAYMENT_CUSTOMER_ACCOUNT_MODES.none,
        allowInlineRegistration: customerAccountMode !== PAYMENT_CUSTOMER_ACCOUNT_MODES.none &&
            field.allowInlineRegistration !== false
    };
};
